export type PermissionAction =
  | "read"
  | "create"
  | "update"
  | "delete"
  | "manage"
  | "approve"
  | "submit"
  | "complete"
  | "run"
  | "cancel"
  | "analytics"
  | "review"
  | "adjust"
  | "assign"
  | "maintain"
  | "retire"
  | "close"
  | "resolve"
  | "publish";

export interface Permission {
  resource: string;
  action: PermissionAction;
  /** Clé canonique RBAC — ex. employee.read */
  key: string;
}

export function buildPermissionKey(
  resource: string,
  action: PermissionAction
): string {
  return `${resource}.${action}`;
}

export function parsePermissionKey(key: string): {
  resource: string;
  action: PermissionAction;
} {
  const [resource, action] = key.split(".");
  return {
    resource: resource ?? key,
    action: (action as PermissionAction) ?? "read",
  };
}
